export default __webpack_public_path__ + "static/media/get-care-onboarding-carousel-web.42818633.png";